
import CustomerItemTable from "@/components/CustomerItemTable.vue";
import Vue from 'vue'
export default Vue.extend({
  name: 'CustomerHomepageItemNotInBarrel',
  components: {CustomerItemTable},
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  data: ()=>({
    open: false,
    panel: [0]
  }),
  created(){
    if(this.$route.params.openNotpackedTable){
      this.open = true;
      setTimeout(()=>{
        window.location.href = '#customerUnpackedItemHeader'
      },1500)
    }
  }
})
